/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { CheckCircle } from "@mui/icons-material"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useHistory } from "react-router-dom"
import { paths, VerticaisManager } from "src/components/vendas/VerticaisManager"
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api"
import { useObservable } from "src/framework/store/storeUtil"
import { formState$ } from "src/store/vendas/projetos/store"
import theme from "src/theme/light"
import { DEFAULT_PROJETO } from "../constants"
import { Projeto, TipoProposta } from "../types"
import { salvarProjeto } from "../utils/salvarProjeto"
import { ValorTotal } from "./containers/ValorTotal"
import { KitConfirmationModal } from "./containers/KitConfirmationModal"
import { setVendedorInternoModalStatus } from "src/store/vendas/projetos/actions"
import { ProjetosProvider } from "src/providers/ProjetosProvider"
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types"
import { authUser$ } from "src/framework/components/navigations/MenuUser"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR, MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA, MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App"
import { verificaPendenciaTrocaComponente } from "../utils/verificaPendenciaTrocaComponente"
import { showPendenciaTrocaComponenteAlert } from "../utils/showPendenciaTrocaComponenteAlert"
import adminStore from "src/store/AdminStore"
import { LoginStore } from "src/framework/store/LoginStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { isLoading$ } from "src/framework/store/ApiEvents";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";

export type TabName = 'valor_total'
const MSG_FALHA_GERAR_PAGAMENTO = "Falha ao enviar pedido para pagamento";

interface TabProps {
  name: TabName;
  label: string;
  done: boolean;
  disabled: boolean;
}

const useStyles = makeStyles({
  tabIcon: {
    marginRight: 8,
    fontSize: 22
  }
})

const manager = new VerticaisManager(paths, api, apiNoLoading);
const projetosProvider = new ProjetosProvider();

const ProjetoKits = () => {
  const classes = useStyles()
  const history = useHistory();

  const globalFormState = useObservable(formState$)
  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const permissoes = useObservable(LoginStore.permissoes) || [];

  const [kitConfirmationModalIsOpened, setKitConfirmationModalIsOpened] = useState(false)
  const [formState, setFormState] = useState<Projeto>(DEFAULT_PROJETO)
  const [tab, setTab] = useState<TabName>('valor_total')

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(()=>{
    if (globalFormState) {
      setFormState(globalFormState)
    }
  },[globalFormState])

  const afterSave = useCallback(() => {
    const cleanAndRedirect = () => {
      notifierStore.setOpen(false);
      history.replace('/projetos/menu-projetos', { done: true })
      formState$.next(DEFAULT_PROJETO)
    }

    notifierStore.setNotifier({
      content: ['<strong>Obrigado pela sua compra !</strong>', '</br>','O link para pagamento foi enviado para o e-mail informado na compra. Não se esqueça de efetuar o pagamento para que seu pedido seja confirmado.'],
      title: 'Sucesso!',
      onClose: () => cleanAndRedirect(),
      timeOut: 0
    })
    notifierStore.setOpen(true)
    isLoading$.next(false);
  }, [history])

  const rollbackSave = useCallback((idProjeto: number | undefined, message?: string[]) => {
    isLoading$.next(false);
    const remove = async () => {
      const request: IDataRequest = {
        url: `/projetos/deletar/${idProjeto}`,
        data: { motivo: MSG_FALHA_GERAR_PAGAMENTO }
      }
      await api.put(request);
    }

    notifierStore.setNotifier({
      content: (message && message?.some(i => i?.includes("pagamento bloqueado"))) ? message : ['Não foi possível finalizar a sua compra. Tente novamente mais tarde.'],
      title: 'Atenção!',
      onClose: () => notifierStore.setOpen(false),
      timeOut: 0
    })

    if (idProjeto) remove();
    notifierStore.setOpen(true)
  }, [])

  const showErrorMessage = (message: any) => {
    isLoading$.next(false);
    setKitConfirmationModalIsOpened(false);
    setVendedorInternoModalStatus(false);
    notifierStore.setOpen(false);
    if (message?.length) {
      notifierStore.setNotifier({
        title: "Aviso!",
        content: message,
        timeOut: 3000,
        onClose: () => {
          notifierStore.setOpen(false);
        }
      })
      notifierStore.setOpen(true);
    }
  }

  const showMessageApi = (mensagem: string) => {
    isLoading$.next(false);
    setKitConfirmationModalIsOpened(false);
    setVendedorInternoModalStatus(false);
    notifierStore.setOpen(false);
    notifierStore.setNotifier({
      title: "Atenção!",
      content: mensagem,
      timeOut: 2500,
      onFinishTimeout: () => {
        window.location.href = `${window.location.origin}/projetos/menu-projetos`
      },
      onClose: () => {
        notifierStore.setOpen(false);
        window.location.href = `${window.location.origin}/projetos/menu-projetos`
      },
    });
    notifierStore.setOpen(true);
  }

  const save = useCallback((updatedFormState: Partial<Projeto> = {})=>{
    isLoading$.next(true);

    const payload = {
      ...formState,
      ...updatedFormState,
    }

    salvarProjeto(manager, formState?.id, payload, authUser)
    .then(async(response: IDataResponse) => {
      isLoading$.next(true);
      const allowedStatusCode = [STATUS_CODE.OK, STATUS_CODE.CREATED]
      if(allowedStatusCode.includes(response.statusCode)) {
        setKitConfirmationModalIsOpened(false)

        let pagamento = null;
        const codigoVenda = response?.data?.[0]?.codigo_venda || payload.codigo_venda
        if (codigoVenda && payload.tipo_proposta_projeto) {
          pagamento = await projetosProvider.enviarParaPagamento({
            codigo_venda: codigoVenda,
            nota_fiscal_triangular: payload.tipo_faturamento === "integrador_cliente",
            tipo_proposta_envio: payload.tipo_proposta_projeto,
          })
        }

        const successCode: any[] = [200,201,202];
        const enviouPagamento = successCode?.includes(pagamento?.statusCode) || pagamento?.message === 'OK';
        const projetoId = formState?.id || response?.data[0]?.id;

        if (enviouPagamento) {
          if (payload.tipo_proposta_projeto && codigoVenda) {
            await projetosProvider.enviarEmailProposta(codigoVenda, payload.tipo_proposta_projeto);
          }
          afterSave()
        } else {
          let _message: string[] = [];
          const msg = pagamento?.message;

          if (Array.isArray(msg)) {
            _message = [...msg];
          } else if (typeof msg === 'string') {
            _message = [msg];
          }

          rollbackSave(projetoId, _message);
        }
      } else {
        if (response?.message) {
          const message: string[] = Array.isArray(response?.message) ? response?.message : [response?.message];
          const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || message?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
          const mensagemSegmentoRevenda = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
          const mensagemSegmentoDistribuidor = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));
          if (mensagemVigencia) {
            showMessageApi(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO);
          } else if (mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
            showMessageApi(`${mensagemSegmentoRevenda ? MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA : MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR}.`);
          } else {
            showErrorMessage(response?.message);
          }
        }
      }
    }).catch((error: any) => {
      if (error?.message) {
        const message: string[] = Array.isArray(error?.message) ? error?.message : [error?.message];
        const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) 
        || message?.some((message:any) => message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));

        const mensagemSegmentoRevenda = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA) 
          || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA));
            
        const mensagemSegmentoDistribuidor = message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR) 
          || message?.some((message:any) => message?.includes(MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR));

        if (mensagemVigencia) {
          showMessageApi(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO);
        } else if (mensagemSegmentoRevenda || mensagemSegmentoDistribuidor) {
          showMessageApi(`${mensagemSegmentoRevenda ? MENSAGEM_FILTRO_SEGMENTO_CONTA_REVENDA : MENSAGEM_FILTRO_SEGMENTO_CONTA_DISTRIBUIDOR}.`);
        } else {
          showErrorMessage(error?.message);
        }
      }
    })
  },[afterSave, formState])

  const beforeSave = useCallback((tipoProposta: TipoProposta, emailProposta: any) => {
    formState.lista_termo_simulacao_financiamento = formState$.value.lista_termo_simulacao_financiamento;
    const withPermission = PermissionUtil.can(PermissionUtil.PERMISSION_VENDEDORES_LISTAGEM, permissoes);
    if (withPermission && !formState.isEdit) {
      setVendedorInternoModalStatus(true, (vendedor) => {
        save({ vendedor_interno: vendedor, tipo_proposta_projeto: tipoProposta, email_proposta: emailProposta })
      })
    } else {
      save({ tipo_proposta_projeto: tipoProposta, email_proposta: emailProposta })
    }
  },[formState, save, permissoes])

  const handleSave = useCallback(async() => {
    if (formState?.isEdit) {
      const dataProjeto: Projeto | any = {...formState};
      if (formState?.id) {
        await adminStore.getProjetoTrocasPendentes(formState?.id).then((resp) => {
          if (resp && resp?.componentes) dataProjeto.componentes = resp?.componentes;
          if (resp && resp?.componentes_modificados) dataProjeto.componentes_modificados = resp?.componentes_modificados;
        });
      }
      if (verificaPendenciaTrocaComponente(dataProjeto)) {
        showPendenciaTrocaComponenteAlert();
        return;
      }
    }

    setKitConfirmationModalIsOpened(true)
  },[formState.isEdit, formState.simulacao_financiamento?.simulacoes])

  const tabs = useMemo<TabProps[]>(() => {
    return [
      {
        name: 'valor_total',
        label: 'Valor Total',
        done: false,
        disabled: false
      },
    ]
  },[])

  const isOffGrid = useMemo<boolean>(() => {
    return formState?.segmento?.includes('offgrid') === true;
  },[formState?.segmento])

  return (
    <>
      <Paper elevation={0} className="tab-header">
        <TabControl indicatorColor="primary" onChangeTab={(selectedTab) => {
          const currentTab = selectedTab as TabName
          setTab(currentTab)
        }} currentTabName={tab}>
          {tabs.map(item => (
            <TabContent
              disabled={item.disabled}
              name={item.name}
              visible={true}
              label={
                <Box display={isMobile ? "none" : "flex"} justifyContent={"center"} alignItems="center">
                  <CheckCircle htmlColor={item.done ? theme.palette.primary.dark : 'unset'} className={classes.tabIcon} />
                  <span>{item.label}</span>    
                </Box>
              }>
                {item.name === 'valor_total' && tab === 'valor_total' && (
                  <ValorTotal 
                    formState={formState}
                    onChangeFormState={setFormState}
                    onClickBack={() => {
                      formState$.next({ ...formState$.value, ...formState })
    
                      if (formState.isEdit) {
                        history.push(`/projetos/${formState.id}/edicao`, { noReset: true })
                        return
                      }
    
                      history.push('/projetos', { noReset: true })
                    }}
                    onClickNext={handleSave}
                  />
                )}
            </TabContent>
          ))}
        </TabControl>
      </Paper>

      {kitConfirmationModalIsOpened &&
        <KitConfirmationModal
          isOpened={kitConfirmationModalIsOpened}
          close={() => setKitConfirmationModalIsOpened(false)}
          onConfirm={beforeSave}
          showPropostaOptions={formState.geradores_kits.reduce((acc, curr) => acc + curr.quantidade, 0) === 1 && !isOffGrid}
          emailPropostaOriginal={formState?.email_proposta}
        />
      }
    </>
  )
}

export { ProjetoKits }